import axiosVerbose from './axios/axiosVerbose'
import { get } from 'lodash'

import { config } from '../config'
import { parseLocation } from './urlHelper'
import filterParamsConfig from '../constants/filterParamsConfig'
import { logError } from './errors'

/**
 * Log success search result or timed out result to events api
 * @param {Object/null} results
 * @param {Object} query
 * @param {Object} user
 * @param {Boolean} timeout
 */
export const logSearchResult = (
  results,
  location,
  currentSite,
  user = null,
  timeout = false
) => {
  const query = Object.assign({}, parseLocation(location), {
    site: `${currentSite}.net`
  })
  let data = {
    event: 'item.keyword',
    search_phrase: query.term,
    timed_out: timeout,
    site: query.site,
    param_view: 'list',
    param_page: 1
  }

  if (results) {
    data['took'] = results.took
    data['total_hits'] = results.total_hits
    data['param_item_ids'] =
      get(results, 'matches.length') && results.matches.map(item => item.id)
  }

  if (user) {
    data['param_view'] =
      get(user, 'preferences.searchResultsViewType') || 'list'
    if (user.profile) {
      data['username'] = user.profile.username
      data['user_id'] = user.profile.id
      data['envato_id'] = user.profile.envato_id
    }
  }

  const params = Object.keys(query).filter(
    param => ['term', 'site'].indexOf(param) === -1
  )

  params.forEach(param => {
    const paramConfig = filterParamsConfig[param]
    const isMultiple =
      param !== 'category' && paramConfig && paramConfig.isMultiple
    const value = isMultiple ? query[param].split(',') : query[param]

    if (value !== 0 && value) {
      data[`param_${param}`] = value
    }
  })

  if ('sendBeacon' in navigator) {
    navigator.sendBeacon(`${config.eventsApi.URL}/search`, JSON.stringify(data))
  } else {
    axiosVerbose
      .post(`${config.eventsApi.URL}/search`, data, { withCredentials: true })
      .catch(logError)
  }
}



// WEBPACK FOOTER //
// ./common/utils/eventsApi.js